import "antd/es/divider/style";
import _Divider from "antd/es/divider";
import "antd/es/row/style";
import _Row from "antd/es/row";
import "antd/es/grid/style";
import _Grid from "antd/es/grid";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useState, useRef, useEffect } from 'react';
import { LocaleContext } from '../../locale';
import Button from '../../button';
import Element from '../element';
import { calcNamePath } from '../../utils/form-utils';
import FormContext from '../../form-context';
import Typography from '../../typography';
import classnames from 'classnames';
import './style/index.less';
var useBreakpoint = _Grid.useBreakpoint;

var Step = function Step(_ref) {
  var parentName = _ref.parentName,
      _ref$config = _ref.config,
      _ref$config$elements = _ref$config.elements,
      elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
      name = _ref$config.name,
      label = _ref$config.label,
      editButtonLabel = _ref$config.editButtonLabel,
      getButtonDisabledState = _ref$config.getButtonDisabledState,
      disableEditButton = _ref$config.disableEditButton,
      buttonText = _ref$config.buttonText,
      edit = _ref.edit,
      preview = _ref.preview,
      index = _ref.index,
      total = _ref.total,
      handleNext = _ref.handleNext,
      handleEditProp = _ref.handleEdit,
      showLastIndex = _ref.showLastIndex,
      shouldScroll = _ref.shouldScroll;

  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  var _useContext2 = useContext(FormContext),
      continueText = _useContext2.continueText,
      form = _useContext2.form,
      getScrollContainer = _useContext2.getScrollContainer;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      showButton = _useState2[0],
      setShowButton = _useState2[1];

  var containerRef = useRef(null);

  var handleEdit = function handleEdit() {
    return handleEditProp(index);
  };

  var buttonDisabled = getButtonDisabledState && form && getButtonDisabledState(form);

  var _useBreakpoint = useBreakpoint(),
      md = _useBreakpoint.md;

  useEffect(function () {
    var _containerRef$current, _containerRef$current4;

    if (md || !(shouldScroll && edit)) return;
    var scrollContainer = getScrollContainer() || window;
    if (typeof scrollContainer.scrollTo !== 'function') return;

    if (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetTop) {
      var _containerRef$current2, _containerRef$current3;

      scrollContainer.scrollTo.length === 2 ? scrollContainer.scrollTo(0, (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetTop) - 50) : scrollContainer.scrollTo({
        top: (containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.offsetTop) - 50,
        behavior: 'smooth'
      });
      return;
    }

    containerRef === null || containerRef === void 0 ? void 0 : (_containerRef$current4 = containerRef.current) === null || _containerRef$current4 === void 0 ? void 0 : _containerRef$current4.scrollIntoView();
  }, [shouldScroll, edit]);
  return _jsxs(_Fragment, {
    children: [_jsxs("div", {
      className: classnames('igloo-hstep-container', {
        'igloo-hstep-container-preview': preview
      }),
      ref: containerRef,
      children: [_jsxs(Typography, {
        className: "igloo-hstep-label",
        level: "h3a",
        children: [_jsx("span", {
          className: "igloo-hstep-label-text",
          children: label
        }), preview && _jsx(Button, {
          type: "link",
          className: "igloo-hstep-label-edit",
          onClick: handleEdit,
          disabled: disableEditButton,
          children: editButtonLabel || formatMessage({
            id: 'Edit'
          })
        }), edit && !md && _jsxs(Typography, {
          level: "body3",
          children: [index + 1, "/", total]
        })]
      }), (edit || preview) && _jsxs("div", {
        className: 'igloo-hstep-content',
        children: [_jsx(_Row, {
          gutter: [32, preview ? 16 : 24],
          children: elements.map(function (child, index) {
            return _jsx(Element, {
              config: child,
              parentName: calcNamePath(parentName, name),
              setShowStepButton: setShowButton,
              preview: preview
            }, index);
          })
        }), edit && showButton && md && _jsx(Button, {
          onClick: handleNext,
          className: 'igloo-hstep-button',
          type: "primary",
          disabled: buttonDisabled,
          children: buttonText || continueText || formatMessage({
            id: 'Continue'
          })
        })]
      }), !edit && !preview && _jsx(_Divider, {
        className: "igloo-hstep-divider"
      })]
    }), edit && showButton && !md && _jsx("div", {
      className: "igloo-hstep-button-container",
      children: _jsx(Button, {
        onClick: handleNext,
        className: 'igloo-hstep-button',
        type: "primary",
        disabled: buttonDisabled,
        children: buttonText || continueText || formatMessage({
          id: 'Continue'
        })
      })
    })]
  });
};

export default Step;